var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21094 6.25C0.695312 6.25 0.4375 6.85938 0.8125 7.21094L3.60156 10C3.8125 10.2344 4.16406 10.2344 4.39844 10L7.1875 7.21094C7.53906 6.85938 7.28125 6.25 6.78906 6.25H1.21094ZM7.1875 3.78906L4.39844 1C4.16406 0.789062 3.8125 0.789062 3.60156 1L0.8125 3.78906C0.4375 4.16406 0.695312 4.75 1.21094 4.75H6.78906C7.28125 4.75 7.53906 4.16406 7.1875 3.78906Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.d3b50c10.svg";
export { ForwardRef as ReactComponent };